import { render, staticRenderFns } from "./BasisSection.vue?vue&type=template&id=386afcbe&scoped=true"
import script from "./BasisSection.vue?vue&type=script&lang=js"
export * from "./BasisSection.vue?vue&type=script&lang=js"
import style0 from "./BasisSection.vue?vue&type=style&index=0&id=386afcbe&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386afcbe",
  null
  
)

export default component.exports